import { useState } from 'react';
import WarehouseCommonApi from '../../../../../API/warehouse/common-api';
import { Row, WhiteBlock } from '../../../../../components/Basic/Blocks';
import { Button } from '../../../../../components/Basic/Buttons';
import { Input } from '../../../../../components/Basic/Inputs';
import { TYPE_BUTTONS } from '../../../../../constans';
import OneMarket from './OneMarket';
import styles from './styles.module.scss';

const MarketBlock = ({ id, marketsCard = {} }) => {
  const [markets, setMarkets] = useState({});
  const [newId, setNewId] = useState('');
  const [map, setMap] = useState({
    ozon: {},
    ozon1: {},
    ozon2: {},
    ozon3: {},
    ozon4: {},
    ozon5: {},
    ozon6: {},
    ozon7: {},
    yandex: {},
    yandex1: {},
    yandex2: {},
    yandex3: {},
    yandex4: {},
    yandex5: {},
    yandex6: {},
    yandex7: {},
    yandex8: {},
    wb: {},
    wb2: {},
    wb3: {},
    wb4: {},
    wb5: {},
    wb6: {},
    wb7: {},
    sber: {},
    sber2: {},
    megamarket1: {},
    megamarket2: {},
    kuper1: {},
  });

  const changeCards = async () => {
    await WarehouseCommonApi.changeMarketPairs({ data: { warehouseId: id, newWarehouseId: newId } });
  };

  const data = Object.keys(marketsCard).filter((m) => marketsCard[m]?.length > 0) || [];
  return (
    <WhiteBlock title="Размещение на площадках" className={styles.market_block} minimize={true}>
      <Row style={{ alignItems: 'flex-end', marginBottom: '10px' }}>
        <Button
          type={TYPE_BUTTONS.GREEN}
          style={{ marginRight: '10px' }}
          onClick={changeCards}
          disabled={newId.length === 0}
        >
          Поменять артикул
        </Button>

        <Input label={'Артикул новой карточки'} value={newId} onChange={(id) => setNewId(id)} />
      </Row>
      {/* eslint-disable-next-line array-callback-return */}
      {data.map((m) => {
        return marketsCard[m].map((item) => {
          return <OneMarket market={m} p={item} key={`${m}${item.offer_id}`} info={item} />;
        });
      })}
    </WhiteBlock>
  );
};

export default MarketBlock;
